// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"acc323bc","977":"940bbdf4"}[chunkId] + ".chunk.js";
};